import { useState } from 'react'

import { Tooltip } from '@material-ui/core'
import {
  TableFooter,
  TableCellStyled,
  TableContainerStyled,
  TableRowStyled,
  TableStyled,
  Row
} from 'components'
import { StatusIcon, ViewFileIcon } from 'components/Icons'
import { useFile } from 'hooks'
import moment from 'moment'
import useHandleViewFile from 'pages/Supplier/AttachDocuments/ThirdPartyAdministration/context'
import { SearchDocuments } from 'services/Supplier/ThirdPartyAdministration'
import { COLORS, FORMAT } from 'utils'

import { TableBody, TableHead } from './TableSearch.styles'

interface ITableSearch {
  tableData: SearchDocuments[]
  page?: number
  rowsPerPage?: number
  setRowsPerPage?: (_page: number) => void
  setPage?: React.Dispatch<React.SetStateAction<number>>
  rowsSize: number
  // handleDownloadDocument: (_externalID: number) => void
}
export const TableSearch: React.FC<ITableSearch> = ({
  tableData,
  page,
  setPage,
  rowsPerPage,
  rowsSize,
  setRowsPerPage
  // handleDownloadDocument
}) => {
  const { handleViewFile } = useHandleViewFile()

  const handleChangePage = (newPage: number) => setPage(newPage + 1)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value))
    setPage(1)
  }

  // const getPendingDays = (dtAnexado: string | Date) => {
  //   return moment(dtAnexado).format("YYYY") === "0001"
  //     ? "- - - - - - - - -"
  //     : moment().diff(moment(dtAnexado), "days")
  // }

  const formatDate = (date: string | Date) => {
    return moment(date).format('YYYY') === '0001'
      ? '- - - - - - - - -'
      : moment(date).format('DD/MM/YYYY')
  }

  const formatCompetencia = (comp: string) => {
    return comp.trim().substring(4, 6) + '/' + comp.trim().substring(0, 4)
  }

  const handleStatus = (status: string) => {
    if (
      status === 'Green' ||
      status === 'Aprovado' ||
      status === 'Liberado' ||
      status === 'L'
    )
      return 'Aprovado'
    if (
      status === 'Yellow' ||
      status === 'Analisar' ||
      status === 'Analisando' ||
      status === 'PendenteDocumento' ||
      status === 'P'
    )
      return 'Em análise'
    if (status === 'Red' || status === 'Recusado' || status === 'B')
      return 'Reprovado'
    return 'Pendente envio'
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHead>
            <TableRowStyled>
              <TableCellStyled>Contrato</TableCellStyled>
              <TableCellStyled>Tipo Documento</TableCellStyled>
              <TableCellStyled>Nome Fornecedor</TableCellStyled>
              <TableCellStyled align="center">Data Anexada</TableCellStyled>
              <TableCellStyled align="center">Competencia</TableCellStyled>
              <TableCellStyled align="center">Dias Pendentes</TableCellStyled>
              <TableCellStyled align="center">Qtd. Analise</TableCellStyled>
              <TableCellStyled align="center">Retorno Análise</TableCellStyled>
              <TableCellStyled align="center">Status</TableCellStyled>
              <TableCellStyled padding="checkbox" align="center">
                Ações
              </TableCellStyled>
            </TableRowStyled>
          </TableHead>
          <TableBody>
            {tableData?.map((row, index) => (
              <TableRowStyled key={index.toString()}>
                <TableCellStyled>
                  {row?.cdContrato || '- - - - - - - - -'}
                </TableCellStyled>
                <TableCellStyled>
                  {row?.txTipo || '- - - - - - - - -'}
                </TableCellStyled>
                <TableCellStyled>{row.nmFornecedor}</TableCellStyled>
                <TableCellStyled align="center">
                  {formatDate(row?.dtAnexado)}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {formatCompetencia(row?.competencia.toString()) ||
                    '- - - - - - - - -'}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {row?.diasPendentes}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {row?.qtdAnalises || '- - - - - - - -'}
                </TableCellStyled>
                {/* <TableCellStyled align="center">{row?.qtdAnalises || '- - - - - - - - -'}</TableCellStyled> */}
                <TableCellStyled align="center">
                  {formatDate(row?.retornoAnalise)}
                </TableCellStyled>
                <Tooltip
                  arrow
                  title={handleStatus(String(row?.cdStatusAnalise))}
                  placement="left"
                >
                  <TableCellStyled align="center">
                    <StatusIcon
                      value={String(row?.cdStatusAnalise)}
                      marginLeft="auto"
                      marginRight="auto"
                    />
                  </TableCellStyled>
                </Tooltip>
                <TableCellStyled align="center">
                  <Row alignItems="center" justifyContent="center">
                    <ViewFileIcon
                      onClick={() =>
                        handleViewFile({ gedExternalID: row.gedExternalId })
                      }
                      cursor="pointer"
                      disabled={
                        !row.gedExternalId &&
                        (row?.dtAnexado > new Date('0001-01-01') ||
                          row?.cdStatusAnalise === 'Pendente')
                      }
                    />
                    {/* <DownloadIcon onClick={() => handleDownloadDocument(row?.gedExternalId)} /> */}
                  </Row>
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBody>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page - 1}
        rows={tableData}
        typeFooter="offline"
        rowsPerPage={rowsPerPage}
        totalItems={rowsSize}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}
